<template>
  <AppButton
    data-send-message
    class="tw-p-0 tw-w-8"
    :type="buttonType"
    :loading="loading"
    :disabled="loading || disabled"
    @click.prevent="handleAction"
  >
    <AppIcon v-show="!loading" :shape="buttonIcon" size="26" color="white" />
  </AppButton>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'

import { Nullable } from '@shared/models/types/primary'

export default defineComponent({
  props: {
    error: {
      type: String as PropType<Nullable<string>>,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['action'],
  setup(props, ctx) {
    const handleAction = () => {
      ctx.emit('action')
    }
    const isError = computed(() => !!props.error)
    const buttonType = computed(() => (isError.value ? 'danger' : 'primary'))
    const buttonIcon = computed(() => (isError.value ? 'resend' : 'send-icon'))

    return {
      buttonType,
      buttonIcon,
      handleAction,
      isError,
    }
  },
})
</script>
